import React from 'react';

function AnswerAlternativeListItem(props) {
	const classChosen = props.chosen ? "chosen" : "";
	const classNormal = props.normal ? "normal" : "";
	return (
		<li
			className={"answer-alternative-li " + classChosen + " " + classNormal}
			id={props.id}
			index={props.index}
			onClick={props.temporaryAnswer}
		>
			<div
				className="answer-alternative-circle">
				{props.index}
			</div>
			<div
				className="answer-alternative-text">
				<p >{props.answer.text}</p>
			</div>
		</li>
	);
}

export default AnswerAlternativeListItem;



// WEBPACK FOOTER //
// ./src/components/AnswerAlternativeListItem.js